// App-specific config

// Using CommonJS instead of ES2015+ export, because we also need to
// provide this object to Webpack in vue.config.js.

const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL || 'https://dev.fcform.swiis.com'
const formsBaseUrl = apiBaseUrl + '/forms'

// console.log(process.env, '---- environment variables ---- ') // eslint-disable-line no-console
const apiVersion = 'v1'
const formsUrl = `${formsBaseUrl}/api/${apiVersion}`
const apiUrl = `${apiBaseUrl}/api/${apiVersion}`
const apiAddressKey = 'ak_k3y8imeig7546LkpmYXbODHwZeGKK'
let defaultConfig = {
  devServer: {
    disableHostCheck: true,
    port: 4000,
    public: '0.0.0.0:4000',
  },
  title: 'FC Form Application',
  description: 'FC Form front-end',
  apiUrl: apiUrl,
  formsUrl: formsUrl,
  apiAddressKey: apiAddressKey,
}

exports.appConfig = defaultConfig
